module.exports = __webpack_public_path__ + "static/media/copyright.e4db8a10.pdf";